import axios from 'axios'

// URL base dell'API per i progetti, recuperato dall'env file

const PROGETTO_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'progetto'

const headers = { 'Content-Type': 'application/json' }

class ProgettoService {

    /**
     * Salva o aggiorna un progetto nel sistema.
     * Effettua una richiesta POST a `/progetto/create` con i dati del progetto.
     *
     * @param {Object} progetto - Oggetto contenente i dettagli del progetto da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    creaProgetto(progetto) {
        return axios.post(PROGETTO_REST_API_URL + "/create", progetto, headers)
    }
    /**
     * Recupera un progetto specifico in base al suo ID.
     * Effettua una richiesta GET a `/progetto/{progId}`.
     *
     * @param {number} progId - L'ID del progetto da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli del progetto.
     */
    getProgetto(progId) {
        return axios.get(PROGETTO_REST_API_URL + `/${progId}`)
    }

    /**
     * Salva o aggiorna un progetto nel sistema.
     * Effettua una richiesta POST a `/progetto/save` con i dati del progetto.
     *
     * @param {Object} progetto - Oggetto contenente i dettagli del progetto da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveProgetto(progetto) {
        return axios.post(PROGETTO_REST_API_URL + "/save", progetto, headers)
    }

    // Metodo per ottenere il conteggio dei progetti per una specifica iniziativa
    getCountByInitiative(iniId) {
        return axios.get(`${PROGETTO_REST_API_URL}/count/${iniId}`, { headers });
    }
    // Metodo per ottenere il conteggio dei progetti non in validazione per una specifica iniziativa
    getCountProgettiValidByIniziativaId(iniId) {
        return axios.get(`${PROGETTO_REST_API_URL}/countValidProg/${iniId}`, { headers });
    }

    

}

// Creazione dell'istanza per essere importata direttamente nei componenti
const progettoServiceInstance = new ProgettoService()
export default progettoServiceInstance;